export const fontTypes = [
  'heading-regular',
  'heading-small',
  'title-large',
  'title-regular',
  'title-small',
  'title-very-small',
  'paragraph-regular',
  'paragraph-small',
  'paragraph-very-small',
  'button-regular',
  'button-small',
] as const

export type FontType = (typeof fontTypes)[number]

export const fontColors = [
  'primary',
  'primary-alt',
  'secondary',
  'tertiary',
  'danger',
  'warning',
  'success',
  'inherit',
  'brand',
  'placeholder',
  'info',
] as const

export type FontColor = (typeof fontColors)[number]

export const lookupFontColor = (fontColor: FontColor): string => {
  if (fontColor === 'inherit') return ''

  if (fontColor === 'brand') return 'misc-brand'

  if (fontColor === 'danger') return 'status-danger'

  if (fontColor === 'success') return 'status-success'

  if (fontColor === 'warning') return 'status-warning'

  if (fontColor === 'info') return 'status-info'

  return `text-color-${fontColor}`
}
